// Import scripts and styles
import './scripts';
import './styles/index.scss';

// Import all images
const imagesCtx = require.context('./images', false, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);
imagesCtx.keys().forEach(imagesCtx);
